import { getResourceFromCms } from '@namespace/helpers';

export const getBonusTemplatesImages = () =>
  getResourceFromCms('/bonusTemplatesImages');
